module.exports = __webpack_public_path__ + "img/hair_front_female_right_part.2e7b24c6.png";